import { render, staticRenderFns } from "./FilterPanel.vue?vue&type=template&id=56a2f228&scoped=true&lang=pug&"
import script from "./FilterPanel.vue?vue&type=script&lang=js&"
export * from "./FilterPanel.vue?vue&type=script&lang=js&"
import style0 from "./FilterPanel.vue?vue&type=style&index=0&id=56a2f228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2f228",
  null
  
)

export default component.exports